// extracted by mini-css-extract-plugin
export default {"horizontalSeparator":"SegmentedMenu_horizontalSeparator__-dpJK","tabMenuContainer":"SegmentedMenu_tabMenuContainer__Nn+ug","bottomBar":"SegmentedMenu_bottomBar__tSx2k"};